export enum EmploymentSubjectEnumeration {
	SUBJECT_TO_DUTY_OF_MAINTENANCE = 'subjectToDutyOfMaintenance',
	VOLUNTARY = 'voluntary',
}
